import Action from '../Action'
import styles from './style.styl'



const OutboundSendFrom = ({ onEditClick, isOutreachConnected }) => (
  <Action onEditClick={onEditClick}>
    <div className={styles.OutboundSendFrom}>
      {isOutreachConnected ?<div>
        <p>
          This Welcome Message will send from the teammate who sent the email using Drift, or who enrolled them in an <a href="https://app.drift.com/settings/setup/outreach">Outreach sequence</a>.
        </p>
        <br/>
        <p>
          <a onClick={onEditClick}>Invite your teammates to use the extension.</a>
        </p>
      </div> :
      <p>
          This Welcome Message will send from the teammate who sent the Drift Sequence or the tracked email from
          the Drift Extension. <a onClick={onEditClick}>Invite your teammates to use the extension.</a>
        </p>
      }
    </div>
  </Action>
)

export default OutboundSendFrom



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/WelcomeMessage/OutboundSendFrom.js